import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

let scene, renderer, camera, controls;

function animate() {
  requestAnimationFrame(animate);
  renderer.render(scene, camera);
  controls.update();
}

function initThree(canvas) {
  // rhino uses z as up direction
  THREE.Object3D.DefaultUp = new THREE.Vector3(0, 0, 1);

  scene = new THREE.Scene();
  scene.background = new THREE.Color("#f2f2f2");
  const aspectRatio = window.innerWidth / window.innerHeight;
  camera = new THREE.PerspectiveCamera(5, aspectRatio, 0.1, 1000);

  const light = new THREE.DirectionalLight(0xffffff, 1);
  light.position.set(0, 0, 0);
  light.target.position.set(-4, 0, -4);
  camera.add(light);
  camera.add(light.target);

  const axesHelper = new THREE.AxesHelper(3);
  scene.add(axesHelper);

  scene.add(camera);

  // Rhino models are z-up, so set this as the default
  // camera.up.set(0, 0, 1);

  camera.position.z = 50;
  camera.position.y = 90;

  renderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas,
  });

  renderer.shadowMap.enabled = true;
  renderer.setSize(window.innerWidth, window.innerHeight);

  controls = new OrbitControls(camera, renderer.domElement);

  /* rotate to use z as up axis */
  var grid = new THREE.GridHelper(
    100,
    100,
    "rgb(190, 190, 190)",
    "rgb(220, 220, 220)"
  );
  grid.material.overdraw = false;
  grid.material.alphaToCoverage = true;
  grid.material.transparent = true;
  grid.material.opacity = 1;
  grid.rotateX(Math.PI / 2);
  scene.add(grid);

  window.addEventListener("resize", onWindowResize, false);

  animate();
}

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}

export { scene, renderer, camera, initThree };
